module.exports = __webpack_public_path__ + "img/Info-icon-lg-blue.3ff0933a.svg";